import { Metadata } from '../../../../../utils/spds/metadata';
import Super from '../base.gjs';
import styles from './warning.module.scss';

const METADATA = Metadata.define({
  description: 'Primary warning badge indicator.',
  name: 'Warning Primary Badge',
});

export default class SpdsIndicatorBadgeWarningPrimary extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  variantClass = 'spds-indicator-badge-warning';
  variantStyles = styles;
}

export const BADGE_WARNING_PRIMARY_METADATA = SpdsIndicatorBadgeWarningPrimary.metadata;
